import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { EntityWithTitle, entityWithTitleSchema } from './entity-with-title';
import { PlayerVoucherItem, playerVoucherItemSchema } from './player-voucher-item';

export type VoucherItem = {
	currentDeposit: number;
	totalDeposit: number;
	currentWagering: number;
	totalWagering: number;
};

export type Player = {
	id: number;
	name: string;
	balance: number;
	order: number;
	isConnected: boolean;
	voucherItem: PlayerVoucherItem | null;
};

export const voucherItemSchema: ZodType<VoucherItem> = z.object({
	currentDeposit: z.number(),
	totalDeposit: z.number(),
	currentWagering: z.number(),
	totalWagering: z.number(),
});

export const playerSchema: ZodType<Player> = z.object({
	id: z.number(),
	name: z.string(),
	balance: z.number(),
	order: z.number(),
	isConnected: z.boolean(),
	voucherItem: playerVoucherItemSchema.nullable(),
});

export type PlayerDetails = {
	id: number;
	name: string;
	account: EntityWithName;
	cashdesk: EntityWithName;
	game: EntityWithTitle;
	device: EntityWithName;
	currency: string;
	balance: number;
	isConnected: boolean;
};

export const playerDetailsSchema: ZodType<PlayerDetails> = z.object({
	id: z.number(),
	name: z.string(),
	account: entityWithNameSchema,
	cashdesk: entityWithNameSchema,
	game: entityWithTitleSchema,
	device: entityWithNameSchema,
	currency: z.string(),
	balance: z.number(),
	isConnected: z.boolean(),
});

export type PlayerRegistryItem = PlayerDetails;

export const playerRegistryItemSchema = playerDetailsSchema;
